import Vue from 'vue'

Vue.mixin({
    methods: {
        transfromEnglishDateToGerman: str => str.split('-').reverse().join('.'),
        displayDateGerman (date) {
            return date.toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}) + ' ' + date.toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit', second: '2-digit'})
        }
    }
})
